
export const faCommon = {
  // Navigation
  'nav.home': 'خانه',
  'nav.about': 'درباره ما',
  'nav.services': 'خدمات',
  'nav.products': 'محصولات',
  'nav.projects': 'پروژه‌ها',
  'nav.partners': 'شرکا',
  'nav.news': 'اخبار',
  'nav.contact': 'تماس با ما',
  
  // Common buttons
  'btn.readMore': 'ادامه مطلب',
  'btn.contact': 'تماس با ما',
  'btn.consultation': 'مشاوره رایگان',
  'btn.viewProjects': 'مشاهده پروژه‌ها',
  'btn.learnMore': 'بیشتر بدانید',
  'btn.callUs': 'تماس بگیرید',
  'btn.requestConsultation': 'درخواست مشاوره',
  'btn.viewDetails': 'مشاهده جزئیات',
  'btn.buy': 'خرید',
  'btn.subscribe': 'عضویت',
  'btn.viewAll': 'مشاهده همه',
  'btn.getQuote': 'دریافت قیمت',
  'btn.viewCatalog': 'مشاهده کاتالوگ کامل',
  'btn.contactExperts': 'تماس با کارشناسان',
  
  // Common phrases
  'common.years': 'سال',
  'common.experience': 'تجربه',
  'common.projects': 'پروژه',
  'common.customers': 'مشتری',
  'common.readTime': 'دقیقه مطالعه',
  'common.location': 'موقعیت',
  'common.area': 'مساحت',
  'common.established': 'تأسیس',
  'common.employees': 'کارمند',
  'common.specialization': 'تخصص',
  'common.category': 'دسته‌بندی',
  'common.tags': 'برچسب‌ها',
  'common.date': 'تاریخ',
  'common.search': 'جستجو',
  'common.filter': 'فیلتر',
  'common.all': 'همه',
  'common.new': 'جدید',
  'common.found': 'یافت شد',
  'common.searchPlaceholder': 'جستجو در محصولات...',
  
  // Company info
  'company.name': 'آریا گرین هاوس',
  'company.tagline': 'شرکت گلخانه سبز آریا',
  'company.description': 'طراح، سازنده و تجهیزکننده گلخانه‌های شیشه‌ای هوشمند در ایران',
  'company.phone': '(+۹۸)۲۱-۸۸۴۴ ۱۳۸۶\n(+۹۸)۹۱۲-۹۰۹۵ ۳۰۲',
  'company.email': 'AriaGreenhouse.Co@Gmail.com',
  'company.address': 'تهران، خیابان مطهری، خیابان یوسفیان، بن‌بست شکوه، پلاک ۶',
  'company.warehouse1': 'انبار جاجرود',
  'company.warehouse2': 'انبار شوش تهران',
  'company.salesManager': '۰۹۱۲۹۰۹۵۳۰۲',
  
  // Footer
  'footer.quickLinks': 'لینک‌های سریع',
  'footer.services': 'خدمات ما',
  'footer.contactInfo': 'تماس با ما',
  'footer.copyright': '© 2024 آریا گرین هاوس. تمامی حقوق محفوظ است.',
  'footer.privacy': 'حریم خصوصی',
  'footer.terms': 'شرایط استفاده',
  'footer.madeWith': 'Made with Readdy',
  
  // About page hero section
  'about.hero.badge': 'پیشرو در صنعت گلخانه‌سازی',
  'about.hero.title': 'آریا گرین هاوس',
  'about.hero.subtitle': 'ارائه‌دهنده پیشرو راه‌حل‌های گلخانه‌ای هوشمند در ایران',
  'about.hero.description': 'با بیش از ۱۵ سال تجربه در طراحی، ساخت و تجهیز گلخانه‌های مدرن، ما به کشاورزان کمک می‌کنیم تا با استفاده از فناوری‌های پیشرفته، بهره‌وری بالاتری کسب کنند.',
  'about.hero.features.experience': 'تجربه ۱۵ ساله',
  'about.hero.features.experience_desc': 'در طراحی و ساخت گلخانه‌های مدرن',
  'about.hero.features.international': 'همکاری بین‌المللی',
  'about.hero.features.international_desc': 'با معتبرترین شرکت‌های جهانی',
  'about.hero.cta.contact': 'تماس با ما',
  'about.hero.cta.projects': 'مشاهده پروژه‌ها',
  'about.hero.achievement.title': 'برترین شرکت گلخانه‌سازی ایران',
  'about.hero.achievement.description': 'دریافت‌کننده جوایز متعدد در صنعت کشاورزی',
  
  // About page stats
  'about.stats.experience': 'سال تجربه',
  'about.stats.projects': 'پروژه موفق',
  'about.stats.area': 'متر مربع گلخانه',
  'about.stats.customers': 'مشتری راضی',
  
  // About page story section - Enhanced
  'about.story.badge': 'داستان موفقیت گلخانه سبز آریا',
  'about.story.title': 'داستان ما',
  'about.story.subtitle': 'سفری از ایده تا پیشرفت در صنعت گلخانه‌سازی ایران',
  'about.story.paragraph1': 'گلخانه سبز آریا در سال ۲۰۰۹ با هدف انقلاب در صنعت کشاورزی ایران تأسیس شد. آنچه به عنوان یک شرکت کوچک مهندسی آغاز شد، امروز به یکی از پیشروترین شرکت‌های گلخانه‌سازی کشور تبدیل شده است.',
  'about.story.paragraph2': 'گلخانه سبز آریا با ترکیب دانش فنی داخلی و تکنولوژی‌های پیشرفته بین‌المللی، توانسته‌ایم بیش از ۵۰ پروژه بزرگ را با موفقیت به پایان برسانیم. از گلخانه‌های خانوادگی کوچک تا مجتمع‌های تجاری بزرگ، همه در حوزه تخصص گلخانه سبز آریا قرار دارند.',
  'about.story.paragraph3': 'امروز، گلخانه سبز آریا همچنان در مسیر نوآوری و بهبود مستمر قدم برمی‌داریم و هدف ما کمک به توسعه کشاورزی پایدار و مدرن در ایران و منطقه است.',
  'about.story.image_alt': 'تاریخچه شرکت گلخانه سبز آریا',
  
  // Story section - Founding
  'about.story.founding.title': 'تأسیس گلخانه سبز آریا (۲۰۰۹)',
  'about.story.founding.description': 'گلخانه سبز آریا با رؤیای ایجاد تحولی بنیادین در صنعت کشاورزی ایران آغاز به کار کرد. بنیانگذاران این شرکت با تجربه‌ای غنی در زمینه مهندسی کشاورزی و آشنایی عمیق با چالش‌های کشاورزان ایرانی، تصمیم گرفتند راه‌حلی نوآورانه برای افزایش بهره‌وری و کیفیت محصولات کشاورزی ارائه دهند.',
  
  // Story section - Growth
  'about.story.growth.title': 'رشد و توسعه گلخانه سبز آریا',
  'about.story.growth.description': 'طی سال‌های ۲۰۱۰ تا ۲۰۱۵، گلخانه سبز آریا با اجرای موفقیت‌آمیز پروژه‌های متعدد، اعتماد کشاورزان و سرمایه‌گذاران را جلب کرد. شرکت با گسترش تیم متخصص خود و سرمایه‌گذاری در تجهیزات پیشرفته، توانست خدمات خود را از طراحی ساده گلخانه‌ها به ارائه راه‌حل‌های جامع و هوشمند گسترش دهد.',
  
  // Story section - Achievements
  'about.story.achievements.title': 'دستاوردها و موفقیت‌های گلخانه سبز آریا',
  'about.story.achievements.description': 'از سال ۲۰۱۶ به بعد، گلخانه سبز آریا به عنوان یکی از پیشگامان صنعت گلخانه‌سازی در ایران شناخته شد. دریافت گواهینامه‌های بین‌المللی کیفیت، همکاری با شرکت‌های معتبر اروپایی و اجرای بزرگترین پروژه‌های گلخانه‌ای کشور، از جمله مهم‌ترین دستاوردهای این دوره محسوب می‌شود.',
  
  // Story section - Highlight
  'about.story.highlight.title': 'نقطه عطف گلخانه سبز آریا',
  'about.story.highlight.description': 'اجرای موفقیت‌آمیز بزرگترین پروژه گلخانه‌ای خاورمیانه با مساحت ۱۰ هکتار در سال ۲۰۲۲',
  
  // Timeline sections
  'about.story.timeline.title': 'مراحل پیشرفت گلخانه سبز آریا',
  'about.story.timeline.2009.title': 'آغاز راه',
  'about.story.timeline.2009.description': 'تأسیس گلخانه سبز آریا با ۳ نفر تیم اولیه و اولین پروژه گلخانه‌ای',
  'about.story.timeline.2015.title': 'گسترش فعالیت‌ها',
  'about.story.timeline.2015.description': 'همکاری با شرکت‌های بین‌المللی و اجرای ۲۰ پروژه موفق',
  'about.story.timeline.2020.title': 'رهبری بازار',
  'about.story.timeline.2020.description': 'تبدیل شدن به بزرگترین شرکت گلخانه‌سازی ایران',
  'about.story.timeline.2024.title': 'چشم‌انداز آینده',
  'about.story.timeline.2024.description': 'توسعه صادرات و حضور در بازارهای منطقه‌ای',
  
  // Milestones - Projects
  'about.story.milestones.projects.title': 'پروژه‌های شاخص گلخانه سبز آریا',
  'about.story.milestones.projects.subtitle': 'بیش از ۱۰۰ پروژه موفق در سراسر کشور',
  'about.story.milestones.projects.description': 'گلخانه سبز آریا تاکنون بیش از ۱۰۰ پروژه گلخانه‌ای را در استان‌های مختلف ایران با موفقیت اجرا کرده است. این پروژه‌ها شامل طیف وسیعی از گلخانه‌های خانوادگی تا مجتمع‌های تجاری بزرگ می‌باشد.',
  'about.story.milestones.projects.item1': 'مجتمع گلخانه‌ای ۱۰ هکتاری اصفهان - بزرگترین پروژه خاورمیانه',
  'about.story.milestones.projects.item2': 'گلخانه‌های تحقیقاتی دانشگاه‌های کشاورزی سراسر کشور',
  'about.story.milestones.projects.item3': 'پروژه‌های صادراتی به کشورهای همسایه',
  
  // Milestones - Expansion
  'about.story.milestones.expansion.title': 'توسعه منطقه‌ای گلخانه سبز آریا',
  'about.story.milestones.expansion.subtitle': 'حضور فعال در بازارهای منطقه‌ای',
  'about.story.milestones.expansion.description': 'گلخانه سبز آریا با تکیه بر تجربه موفق داخلی، فعالیت‌های خود را به کشورهای همسایه گسترش داده است. این توسعه شامل صادرات تجهیزات، ارائه خدمات مشاوره‌ای و اجرای پروژه‌های مشترک می‌باشد.',
  'about.story.milestones.expansion.item1': 'صادرات تجهیزات گلخانه‌ای به عراق، افغانستان و آذربایجان',
  'about.story.milestones.expansion.item2': 'همکاری با شرکت‌های کشاورزی منطقه خلیج فارس',
  'about.story.milestones.expansion.item3': 'ایجاد شعبه‌های نمایندگی در کشورهای هدف',
  
  // Innovation section
  'about.story.innovation.title': 'نوآوری و تحقیقات گلخانه سبز آریا',
  'about.story.innovation.subtitle': 'پیشگام در توسعه فناوری‌های نوین گلخانه‌ای',
  'about.story.innovation.research.title': 'تحقیق و توسعه',
  'about.story.innovation.research.description': 'واحد تحقیق و توسعه گلخانه سبز آریا مستمراً بر روی بهبود تکنولوژی‌های موجود و ابداع راه‌حل‌های نوین کار می‌کند',
  'about.story.innovation.technology.title': 'فناوری هوشمند',
  'about.story.innovation.technology.description': 'پیاده‌سازی سیستم‌های IoT، هوش مصنوعی و اتوماسیون پیشرفته در گلخانه‌های مدرن',
  'about.story.innovation.sustainability.title': 'پایداری محیطی',
  'about.story.innovation.sustainability.description': 'تعهد به حفظ محیط زیست و استفاده بهینه از منابع طبیعی در تمامی پروژه‌ها',
  
  // About page mission, vision, values
  'about.mission.title': 'ماموریت ما',
  'about.mission.description': 'ارائه راه‌حل‌های نوآورانه و پایدار برای افزایش بهره‌وری کشاورزی و حفظ منابع طبیعی از طریق طراحی و ساخت گلخانه‌های هوشمند با استانداردهای بین‌المللی.',
  'about.vision.title': 'چشم‌انداز ما',
  'about.vision.description': 'تبدیل شدن به پیشروترین و معتبرترین شرکت گلخانه‌سازی در منطقه خاورمیانه و کمک به تأمین امنیت غذایی از طریق توسعه کشاورزی مدرن و پایدار.',
  'about.values.title': 'ارزش‌های ما',
  'about.values.description': 'نوآوری، کیفیت، پایداری، صداقت، تعهد به مشتری و مسئولیت اجتماعی، اصول اساسی فعالیت ما در تمامی پروژه‌ها و خدمات محسوب می‌شوند.',
  'about.values.section_title': 'ارزش‌های بنیادین ما',
  'about.values.section_description': 'اصولی که در تمام فعالیت‌های ما راهنما هستند',
  'about.values.innovation.title': 'نوآوری',
  'about.values.innovation.description': 'همواره در جستجوی راه‌حل‌های جدید و بهتر برای چالش‌های کشاورزی',
  'about.values.quality.title': 'کیفیت',
  'about.values.quality.description': 'استفاده از بهترین مواد و تجهیزات با استانداردهای بین‌المللی',
  'about.values.service.title': 'خدمات برتر',
  'about.values.service.description': 'ارائه خدمات جامع از طراحی تا پشتیبانی پس از فروش',
  'about.values.sustainability.title': 'پایداری',
  'about.values.sustainability.description': 'تعهد به حفظ محیط زیست و استفاده بهینه از منابع طبیعی',
  
  // About page team section
  'about.team.title': 'تیم متخصص ما',
  'about.team.description': 'متشکل از بهترین مهندسان و کارشناسان صنعت گلخانه‌سازی',
  'about.team.ceo.name': 'مهندس احمد رضایی',
  'about.team.ceo.position': 'مدیرعامل و بنیانگذار',
  'about.team.ceo.description': 'با بیش از ۲۰ سال تجربه در صنعت کشاورزی و مدیریت پروژه‌های بزرگ گلخانه‌ای',
  'about.team.engineer.name': 'مهندس فاطمه احمدی',
  'about.team.engineer.position': 'مدیر فنی و طراحی',
  'about.team.engineer.description': 'متخصص طراحی گلخانه‌های هوشمند و سیستم‌های کنترل اقلیم',
  'about.team.consultant.name': 'دکتر علی محمدی',
  'about.team.consultant.position': 'مشاور ارشد کشاورزی',
  'about.team.consultant.description': 'دکترای کشاورزی و متخصص سیستم‌های هیدروپونیک و کشت بدون خاک',
  
  // About page CTA section
  'about.cta.title': 'آماده همکاری با ما هستید؟',
  'about.cta.description': 'بیایید درباره چگونگی دستیابی به اهداف گلخانه‌ای شما صحبت کنیم',
  'about.cta.contact': 'تماس با ما',
  'about.cta.services': 'مشاهده خدمات',
  
  // Projects page
  'projects.title': 'پروژه‌های ما',
  'projects.subtitle': 'پروژه‌های موفق گلخانه‌ای در سراسر ایران و منطقه',
  'projects.featured': 'پروژه‌های ویژه',
  'projects.all': 'تمام پروژه‌ها',
  'projects.commercial': 'تجاری',
  'projects.research': 'تحقیقاتی',
  'projects.hydroponic': 'هیدروپونیک',
  'projects.traditional': 'سنتی',
  'projects.sqm': 'متر مربع',
  'projects.completed': 'تکمیل شده',
  'projects.ongoing': 'در حال اجرا',
  'projects.planning': 'در حال برنامه‌ریزی',
  
  // About page
  'about.title': 'درباره آریا گرین هاوس',
  'about.subtitle': 'ارائه‌دهنده پیشرو راه‌حل‌های گلخانه‌ای هوشمند در ایران',
  'about.story': 'داستان ما',
  'about.mission': 'ماموریت ما',
  'about.vision': 'چشم‌انداز ما',
  'about.values': 'ارزش‌های ما',
  'about.team': 'تیم ما',
  'about.achievements': 'دستاوردها',
  'about.storyText1': 'آریا گرین هاوس در سال 2009 تأسیس شد و در خط مقدم فناوری گلخانه‌ای در ایران و منطقه خاورمیانه قرار گرفت. آنچه به عنوان یک شرکت مهندسی کوچک شروع شد، اکنون به ارائه‌دهنده پیشرو راه‌حل‌های گلخانه‌ای هوشمند تبدیل شده است.',
  'about.storyText2': 'سفر ما با یک ماموریت ساده آغاز شد: انقلاب در کشاورزی از طریق فناوری‌های نوآورانه گلخانه‌ای. در طول سال‌ها، ما بیش از 200 پروژه را با موفقیت تکمیل کرده‌ایم، از مزارع خانوادگی کوچک تا عملیات تجاری بزرگ.',
  'about.storyText3': 'امروز، ما همچنان مرزهای ممکن در کشاورزی محیط کنترل‌شده را جابجا می‌کنیم و به کشاورزان کمک می‌کنیم تا عملکرد بالاتری با استفاده از منابع کمتر به دست آورند.',
  'about.missionText': 'ماموریت ما ارائه راه‌حل‌های پایدار و نوآورانه برای افزایش بهره‌وری کشاورزی و حفظ منابع طبیعی است.',
  'about.visionText': 'چشم‌انداز ما تبدیل شدن به پیشرو منطقه‌ای در فناوری گلخانه‌ای هوشمند و کمک به تأمین امنیت غذایی است.',
  'about.valuesText': 'ارزش‌های ما شامل نوآوری، کیفیت، پایداری، و تعهد به رضایت مشتری است.',
  
  // Services page
  'services.title': 'خدمات ما',
  'services.subtitle': 'راه‌حل‌های جامع گلخانه‌ای از طراحی تا نگهداری',
  'services.design': 'طراحی و مهندسی',
  'services.construction': 'ساخت و ساز',
  'services.equipment': 'تأمین تجهیزات',
  'services.maintenance': 'نگهداری',
  'services.consultation': 'مشاوره',
  'services.automation': 'سیستم‌های اتوماسیون',
  'services.mainTitle': 'خدمات آریا گرین هاوس',
  'services.heroSubtitle': 'از طراحی تا بهره‌برداری، همه چیز برای گلخانه‌های هوشمند شما',
  'services.mainServices': 'خدمات اصلی ما',
  'services.mainServicesSubtitle': 'آریا گرین هاوس با ترکیب تجربه داخلی و تکنولوژی بین‌المللی، کامل‌ترین خدمات گلخانه‌ای را ارائه می‌دهد',
  'services.smartDesign': 'طراحی گلخانه‌های هوشمند',
  'services.smartDesignDesc': 'طراحی کامل گلخانه‌های شیشه‌ای با در نظر گیری شرایط اقلیمی، نوع محصول و نیازهای خاص هر پروژه',
  'services.constructionInstall': 'ساخت و نصب گلخانه‌ها',
  'services.constructionInstallDesc': 'ساخت و نصب گلخانه‌های شیشه‌ای با استفاده از بهترین مواد و تجهیزات پیشرفته',
  'services.equipmentAutomation': 'تجهیز و اتوماسیون',
  'services.equipmentAutomationDesc': 'تجهیز گلخانه‌ها با مدرن‌ترین سیستم‌های کنترل و اتوماسیون',
  'services.additionalServices': 'خدمات جانبی',
  'services.additionalServicesSubtitle': 'علاوه بر خدمات اصلی، طیف گسترده‌ای از خدمات تکمیلی ارائه می‌دهیم',
  'services.expertConsultation': 'مشاوره تخصصی',
  'services.expertConsultationDesc': 'ارائه مشاوره فنی و تخصصی در تمامی مراحل پروژه',
  'services.maintenanceRepair': 'نگهداری و تعمیرات',
  'services.maintenanceRepairDesc': 'خدمات پس از فروش و نگهداری دوره‌ای گلخانه‌ها',
  'services.userTraining': 'آموزش کاربران',
  'services.userTrainingDesc': 'آموزش کامل نحوه بهره‌برداری و نگهداری',
  'services.performanceOptimization': 'بهینه‌سازی عملکرد',
  'services.performanceOptimizationDesc': 'تحلیل و بهبود عملکرد گلخانه‌های موجود',
  'services.qualityAssurance': 'ضمانت کیفیت',
  'services.qualityAssuranceDesc': 'ارائه گارانتی و ضمانت کامل روی تمام خدمات',
  'services.support247': 'پشتیبانی ۲۴/۷',
  'services.support247Desc': 'پشتیبانی و راهنمایی در تمامی ساعات شبانه‌روز',
  'services.workProcess': 'فرآیند کاری ما',
  'services.workProcessSubtitle': 'مراحل کامل اجرای پروژه از ابتدا تا انتها',
  'services.initialConsultation': 'مشاوره اولیه',
  'services.initialConsultationDesc': 'بررسی نیازها و امکان‌سنجی پروژه',
  'services.designEstimate': 'طراحی و برآورد',
  'services.designEstimateDesc': 'ارائه طرح کامل و برآورد هزینه‌ها',
  'services.contractSigning': 'عقد قرارداد',
  'services.contractSigningDesc': 'امضای قرارداد و تعیین زمان‌بندی',
  'services.projectExecution': 'اجرای پروژه',
  'services.projectExecutionDesc': 'شروع ساخت و نصب با نظارت کامل',
  'services.testDelivery': 'تست و تحویل',
  'services.testDeliveryDesc': 'آزمایش سیستم‌ها و تحویل نهایی',
  'services.support': 'پشتیبانی',
  'services.supportDesc': 'ارائه خدمات پس از فروش و آموزش',
  'services.advancedTechnologies': 'تکنولوژی‌های پیشرفته',
  'services.advancedTechnologiesSubtitle': 'استفاده از جدیدترین و مدرن‌ترین تکنولوژی‌های دنیا',
  'services.smartClimateControl': 'کنترل اقلیم هوشمند',
  'services.smartClimateControlDesc': 'سیستم‌های پیشرفته کنترل دما، رطوبت و تهویه',
  'services.smartIrrigation': 'آبیاری هوشمند',
  'services.smartIrrigationDesc': 'سیستم آبیاری قطره‌ای با کنترل اتوماتیک',
  'services.remoteMonitoring': 'مونیتورینگ از راه دور',
  'services.remoteMonitoringDesc': 'نظارت و کنترل گلخانه از طریق موبایل و کامپیوتر',
  'services.advancedHydroponics': 'هیدروپونیک پیشرفته',
  'services.advancedHydroponicsDesc': 'سیستم‌های کشت بدون خاک با تغذیه دقیق',
  'services.qualityAssuranceTitle': 'تضمین کیفیت',
  'services.qualityAssuranceSubtitle': 'کیفیت خدمات ما با مجوزها و گواهینامه‌های معتبر تضمین می‌شود',
  'services.dutchTechnology': 'تکنولوژی هلندی',
  'services.dutchTechnologyDesc': 'همکاری با Vander Hoeven',
  'services.europeanStandard': 'استاندارد اروپایی',
  'services.europeanStandardDesc': 'گواهی CE و ISO',
  'services.iranianQuality': 'کیفیت ایرانی',
  'services.iranianQualityDesc': 'تأیید وزارت جهاد کشاورزی',
  'services.completeWarranty': 'ضمانت کامل',
  'services.completeWarrantyDesc': 'گارانٹی ۵ ساله',
  'services.servicePackages': 'پکیج‌های خدماتی',
  'services.servicePackagesSubtitle': 'بسته‌های مختلف خدماتی متناسب با نیاز شما',
  'services.basicPackage': 'پکیج پایه',
  'services.basicPackageDesc': 'مناسب گلخانه‌های کوچک',
  'services.professionalPackage': 'پکیج حرفه‌ای',
  'services.professionalPackageDesc': 'مناسب گلخانه‌های متوسط',
  'services.advancedPackage': 'پکیج پیشرفته',
  'services.advancedPackageDesc': 'مناسب گلخانه‌های بزرگ',
  'services.mostPopular': 'محبوب‌ترین',
  'services.selectPackage': 'انتخاب پکیج',
  'services.contactForPrice': 'تماس بگیرید',
  'services.faq': 'سوالات متداول',
  'services.faqSubtitle': 'پاسخ سوالات رایج در مورد خدمات آریا گرین هاوس',
  'services.readyToStart': 'آماده شروع پروژه‌تان هستید؟',
  'services.readyToStartSubtitle': 'همین الان با کارشناسان ما تماس بگیرید و مشاوره رایگان دریافت کنید',
  
  // Service features
  'services.features.structuralDesign': 'طراحی سازه‌ای مقاوم و استاندارد',
  'services.features.loadCalculation': 'محاسبه بارهای wind و زلزله',
  'services.features.ventilationDesign': 'طراحی سیستم تهویه و کنترل دما',
  'services.features.orientationSelection': 'انتخاب بهترین جهت‌گیری گلخانه',
  'services.features.smartIrrigationDesign': 'طراحی سیستم‌های آبیاری هوشمند',
  'services.features.qualityMaterials': 'استفاده از آلومینیوم و شیشه‌های باکیفیت',
  'services.features.expertInstallation': 'نصب توسط تیم متخصص',
  'services.features.qualityControl': 'کنترل کیفیت در تمام مراحل',
  'services.features.systemTesting': 'تست و راه‌اندازی سیستم‌ها',
  'services.features.completeWarranty': 'ارائه گارانتی کامل',
  'services.features.smartClimateSystem': 'سیستم کنترل اقلیم هوشمند',
  'services.features.automaticIrrigation': 'آبیاری قطره‌ای اتوماتیک',
  'services.features.remoteMonitoringSystem': 'سیستم مونیتورینگ از راه دور',
  'services.features.lightShadeControl': 'کنترل نور و سایه‌بان',
  'services.features.hydroponicFeeding': 'سیستم تغذیه هیدروپونیک',
  
  // Package features
  'services.package.simpleDesign': 'طراحی ساده گلخانه',
  'services.package.constructionInstall': 'ساخت و نصب',
  'services.package.dripIrrigation': 'آبیاری قطره‌ای',
  'services.package.twoYearWarranty': 'گارانتی ۲ ساله',
  'services.package.advancedDesign': 'طراحی پیشرفته',
  'services.package.climateControl': 'سیستم کنترل اقلیم',
  'services.package.smartIrrigation': 'آبیاری هوشمند',
  'services.package.threeYearWarranty': 'گارانتی ۳ ساله',
  'services.package.completeSmartDesign': 'طراحی کامل هوشمند',
  'services.package.fullAutomation': 'اتوماسیون کامل',
  'services.package.remoteMonitoring': 'مونیتورینگ از راه دور',
  'services.package.fiveYearWarranty': 'گارانتی ۵ ساله',
  
  // FAQ questions
  'services.faq.q1': 'زمان اجرای یک پروژه گلخانه چقدر است؟',
  'services.faq.a1': 'زمان اجرا بسته به ابعاد و پیچیدگی پروژه متفاوت است. معمولاً گلخانه‌های کوچک ۲-۳ ماه و گلخانه‌های بزرگ ۴-۶ ماه زمان نیاز دارند.',
  'services.faq.q2': 'آیا گارانتی خدمات شما شامل چه مواردی می‌شود؟',
  'services.faq.a2': 'گارانتی ما شامل ساختار گلخانه، تجهیزات نصب شده، سیستم‌های کنترل و خدمات فنی می‌شود. همچنین پشتیبانی ۲۴/۷ ارائه می‌دهیم.',
  'services.faq.q3': 'امکان طراحی گلخانه‌های سفارشی وجود دارد؟',
  'services.faq.a3': 'بله، ما تمام گلخانه‌ها را بر اساس نیاز مشتری و شرایط محیطی طراحی می‌کنیم. هیچ پروژه‌ای مشابه دیگری نیست.',
  'services.faq.q4': 'هزینه نگهداری سالانه گلخانه چقدر است؟',
  'services.faq.a4': 'هزینه نگهداری بسته به اندازه گلخانه و تجهیزات آن متفاوت است. ما برنامه‌های نگهداری مختلفی ارائه می‌دهیم که می‌تواند از ۵ تا ۱۵ درصد هزینه اولیه باشد.',
  'services.faq.q5': 'آیا آموزش کار با گلخانه ارائه می‌کنید؟',
  'services.faq.a5': 'بله، بعد از تحویل گلخانه، تیم ما آموزش کاملی در زمینه بهره‌برداری، نگهداری و عیب‌یابی به شما ارائه می‌دهد.',
  
  // Products page
  'products.title': 'محصولات و تجهیزات',
  'products.subtitle': 'کامل‌ترین مجموعه تجهیزات و مواد مصرفی گلخانه‌های مدرن',
  'products.structures': 'سازه‌های گلخانه',
  'products.climate': 'کنترل آب و هوا',
  'products.irrigation': 'سیستم‌های آبیاری',
  'products.automation': 'اتوماسیون',
  'products.accessories': 'لوازم جانبی',
  'products.price': 'قیمت',
  'products.specifications': 'مشخصات',
  'products.categories': 'دسته‌بندی محصولات',
  'products.categoriesSubtitle': 'آشنایی با انواع تجهیزات و کاربرد آن‌ها در گلخانه‌های مدرن',
  'products.whyChoose': 'چرا محصولات آریا گرین هاوس؟',
  'products.whyChooseSubtitle': 'مزایای انتخاب محصولات ما برای گلخانه شما',
  'products.techSupport': 'پشتیبانی فنی تخصصی',
  'products.techSupportDesc': 'تیم متخصص ما آماده ارائه مشاوره و راهنمایی در انتخاب بهترین محصولات برای نیازهای خاص گلخانه شما است.',
  'products.ctaTitle': 'آماده خرید محصولات باکیفیت هستید؟',
  'products.ctaSubtitle': 'با ما تماس بگیرید و از مشاوره رایگان برای انتخاب بهترین محصولات استفاده کنید',
  
  // Product categories
  'products.cat.all': 'همه محصولات',
  'products.cat.substrates': 'بسترهای کشت',
  'products.cat.support': 'سیستم‌های نگهداری',
  'products.cat.protection': 'محافظت و کنترل',
  'products.cat.heating': 'سیستم‌های گرمایشی',
  'products.cat.tools': 'ابزار و تجهیزات',
  'products.cat.smart': 'تجهیزات هوشمند',
  
  // Product stats
  'products.stats.diverseProducts': 'محصول متنوع',
  'products.stats.trustedBrands': 'برند معتبر',
  'products.stats.support247': 'پشتیبانی فنی',
  'products.stats.qualityGuarantee': 'ضمانت کیفیت',
  
  // Product features
  'products.features.qualityGuaranteed': 'کیفیت تضمینی',
  'products.features.qualityDesc': 'همه محصولات دارای گواهینامه‌های بین‌المللی و ضمانت کیفیت',
  'products.features.fastShipping': 'ارسال سریع',
  'products.features.fastShippingDesc': 'ارسال به سراسر کشور با بسته‌بندی مناسب و تحویل به موقع',
  'products.features.technicalSupport': 'پشتیبانی فنی',
  'products.features.technicalSupportDesc': 'مشاوره و راهنمایی فنی رایگان برای انتخاب و استفاده از محصولات',
  'products.features.fairPrice': 'قیمت مناسب',
  'products.features.fairPriceDesc': 'بهترین قیمت‌ها با امکان خرید عمده و تخفیف‌های ویژه',
  
  // Support features
  'products.support.freeConsultation': 'مشاوره رایگان قبل از خرید',
  'products.support.installationGuide': 'راهنمایی نصب و راه‌اندازی',
  'products.support.afterSales': 'پشتیبانی پس از فروش',
  'products.support.training': 'آموزش استفاده از محصولات',
  
  // Partners page
  'partners.title': 'شرکای ما',
  'partners.subtitle': 'همکاری با معتبرترین شرکت‌های داخلی و خارجی برای ارائه بهترین خدمات',
  'partners.international': 'بین‌المللی',
  'partners.local': 'داخلی',
  'partners.suppliers': 'تأمین‌کنندگان',
  'partners.distributors': 'توزیع‌کنندگان',
  'partners.since': 'شریک از سال',
  'partners.website': 'مشاهده وب‌سایت',
  'partners.heroTitle': 'شرکای ما',
  'partners.heroSubtitle': 'همکاری با معتبرترین شرکت‌های داخلی و خارجی برای ارائه بهترین خدمات',
  'partners.strategicPartnerships': 'شراکت‌های استراتژیک',
  'partners.strategicPartnershipsDesc': 'آریا گرین هاوس با همکاری نزدیک با شرکت‌های معتبر داخلی و خارجی، بهترین تکنولوژی‌ها و خدمات را در اختیار مشتریان قرار می‌دهد',
  'partners.globalTechnology': 'دسترسی به تکنولوژی جهانی',
  'partners.globalTechnologyDesc': 'بهره‌مندی از آخرین تکنولوژی‌های روز دنیا در صنعت گلخانه‌سازی',
  'partners.qualityGuarantee': 'تضمین کیفیت',
  'partners.qualityGuaranteeDesc': 'استفاده از مواد اولیه و قطعات با کیفیت و استاندارد بین‌المللی',
  'partners.technicalSupport': 'پشتیبانی فنی',
  'partners.technicalSupportDesc': 'دریافت پشتیبانی فنی مستقیم از شرکت‌های سازنده',
  'partners.timelyDelivery': 'تحویل به‌موقع',
  'partners.timelyDeliveryDesc': 'اجرای پروژه‌ها در زمان تعیین شده با کیفیت مطلوب',
  'partners.mainPartners': 'شرکای اصلی',
  'partners.mainPartnersDesc': 'همکاری استراتژیک با پیشگامان صنعت',
  'partners.allPartners': 'همه شرکا',
  'partners.domestic': 'داخلی',
  'partners.technicalPartners': 'شرکای فنی',
  'partners.technicalPartnersDesc': 'همکاری با پیشگامان تکنولوژی گلخانه‌ای',
  'partners.supplierPartners': 'شرکای تأمین‌کننده',
  'partners.supplierPartnersDesc': 'تأمین‌کنندگان مواد اولیه و قطعات با کیفیت',
  'partners.partnershipProcess': 'فرآیند همکاری',
  'partners.partnershipProcessDesc': 'مراحل همکاری آریا گرین هاوس با شرکای بین‌المللی و داخلی',
  'partners.partnerSelection': 'انتخاب شریک',
  'partners.partnerSelectionDesc': 'بررسی و انتخاب شرکای معتبر با تجربه و کیفیت مناسب',
  'partners.negotiationContract': 'مذاکره و قرارداد',
  'partners.negotiationContractDesc': 'انجام مذاکرات فنی و تجاری و عقد قرارداد همکاری',
  'partners.technologyTransfer': 'انتقال تکنولوژی',
  'partners.technologyTransferDesc': 'آموزش تیم فنی و انتقال دانش و تکنولوژی',
  'partners.projectExecution': 'اجرای پروژه',
  'partners.projectExecutionDesc': 'شروع همکاری عملی و اجرای پروژه‌های مشترک',
  'partners.successStories': 'داستان‌های موفقیت',
  'partners.successStoriesDesc': 'نمونه‌هایی از پروژه‌های موفق حاصل از همکاری‌های استراتژیک',
  'partners.isfahanGreenhouse': 'گلخانه هوشمند اصفهان',
  'partners.isfahanGreenhouseDesc': 'اولین گلخانه کاملاً هوشمند ایران با تکنولوژی هلندی',
  'partners.mashadComplex': 'مجتمع کشاورزی مشهد',
  'partners.mashadComplexDesc': 'بزرگترین مجتمع گلخانه‌ای خراسان با استانداردهای اروپایی',
  'partners.ardabilResearch': 'گلخانه تحقیقاتی اردبیل',
  'partners.ardabilResearchDesc': 'مرکز تحقیقات کشاورزی با تجهیزات پیشرفته',
  'partners.domesticPartners': 'شرکای داخلی',
  'partners.interestedInPartnership': 'علاقه‌مند به همکاری هستید؟',
  'partners.interestedInPartnershipDesc': 'آریا گرین هاوس همواره به دنبال گسترش شبکه شرکای خود است. با ما تماس بگیرید و از فرصت‌های همکاری باخبر شوید.',
  'partners.partnerRequest': 'درخواست همکاری',
  'partners.contactUs': 'تماس با ما',
  'partners.moreInfo': 'اطلاعات بیشتر',
  'partners.collaborationMethod': 'نحوه همکاری:',
  'partners.servicesSpecialties': 'خدمات و تخصص‌ها:',
  
  // Partners page specific content
  'partners.netherlands': 'هلند',
  'partners.iran': 'ایران',
  'partners.israel': 'اسرائیل',
  'partners.vanderHoevenSpecialization': 'طراحی و ساخت گلخانه‌های شیشه‌ای',
  'partners.vanderHoevenDescription': 'شرکت Van der Hoeven یکی از پیشگامان صنعت گلخانه‌سازی در هلند است که بیش از 50 سال تجربه در طراحی، ساخت و تجهیز گلخانه‌های شیشه‌ای دارد. این شرکت با ارائه تکنولوژی‌های پیشرفته و راه‌حل‌های نوآورانه، به یکی از معتبرترین برندهای جهانی در حوزه کشاورزی مدرن تبدیل شده است.',
  'partners.vanderHoevenService1': 'طراحی گلخانه‌های شیشه‌ای',
  'partners.vanderHoevenService2': 'سیستم‌های کنترل آب و هوا',
  'partners.vanderHoevenService3': 'تجهیزات آبیاری هوشمند',
  'partners.vanderHoevenService4': 'سیستم‌های انرژی پایدار',
  'partners.vanderHoevenService5': 'مشاوره فنی و طراحی',
  'partners.vanderHoevenAchievement1': 'بیش از 1000 پروژه موفق در سراسر جهان',
  'partners.vanderHoevenAchievement2': 'پیشرو در تکنولوژی گلخانه‌های هوشمند',
  'partners.vanderHoevenAchievement3': 'دارنده گواهینامه‌های بین‌المللی کیفیت',
  'partners.vanderHoevenAchievement4': 'همکاری با بزرگترین تولیدکنندگان جهان',
  'partners.vanderHoevenCollaboration': 'آریا گرین هاوس به‌عنوان تنها نماینده رسمی Van der Hoeven در ایران، مسئولیت انتقال تکنولوژی‌های پیشرفته هلندی به بازار ایران را بر عهده دارد. این همکاری شامل طراحی، ساخت، نصب و راه‌اندازی گلخانه‌های شیشه‌ای با استانداردهای اروپایی است.',
  'partners.chehelsotoonSpecialization': 'تولید درب و پنجره آلومینیوم و PVC',
  'partners.chehelsotoonDescription': 'شرکت چهل‌ستون با بیش از 20 سال تجربه در صنعت درب و پنجره‌سازی، یکی از پیشگامان تولید محصولات آلومینیوم و PVC در ایران است. این شرکت با تکیه بر تکنولوژی روز دنیا و نیروی کار متخصص، محصولاتی با کیفیت بالا و استاندارد اروپایی تولید می‌کند.',
  'partners.chehelsotoonService1': 'تولید درب و پنجره آلومینیوم',
  'partners.chehelsotoonService2': 'سیستم‌های PVC پیشرفته',
  'partners.chehelsotoonService3': 'نمای ساختمان و کرتین وال',
  'partners.chehelsotoonService4': 'شیشه‌های ایمنی و دوجداره',
  'partners.chehelsotoonService5': 'طراحی و اجرای پروژه‌های ساختمانی',
  'partners.chehelsotoonAchievement1': 'بیش از 500 پروژه موفق در سراسر کشور',
  'partners.chehelsotoonAchievement2': 'دارنده گواهینامه‌های استاندارد ملی',
  'partners.chehelsotoonAchievement3': 'همکاری با معتبرترین سازندگان کشور',
  'partners.chehelsotoonAchievement4': 'تولید محصولات با کیفیت اروپایی',
  'partners.chehelsotoonCollaboration': 'همکاری استراتژیک Chehelsotoon با آریا گرین هاوس در زمینه تولید قطعات آلومینیوم و شیشه‌ای گلخانه‌ها، کیفیت و دوام محصولات نهایی را تضمین می‌کند. این شراکت شامل طراحی و تولید سازه‌های مقاوم، سیستم‌های تهویه و درب‌های اتوماتیک گلخانه‌ها است.',
  'partners.privaSpecialization': 'سیستم‌های کنترل آب و هوا',
  'partners.privaDescription': 'تأمین‌کننده سیستم‌های هوشمند کنترل محیط گلخانه',
  'partners.netafimSpecialization': 'سیستم‌های آبیاری قطره‌ای',
  'partners.netafimDescription': 'پیشرو جهانی در تکنولوژی آبیاری هوشمند',
  'partners.philipsSpecialization': 'سیستم‌های نورپردازی LED',
  'partners.philipsDescription': 'تولیدکننده چراغ‌های رشد LED برای گلخانه‌ها',
  'partners.ridderSpecialization': 'اتوماسیون گلخانه',
  'partners.ridderDescription': 'سیستم‌های اتوماسیون و کنترل هوشمند',
  'partners.iranGlassCompany': 'شرکت شیشه ایران',
  'partners.iranGlassSpecialization': 'تولید شیشه‌های تخصصی',
  'partners.iranGlassDescription': 'تأمین‌کننده شیشه‌های مقاوم و با کیفیت برای گلخانه‌ها',
  'partners.mobarakehSteel': 'فولاد مبارکه',
  'partners.mobarakehSteelSpecialization': 'تولید سازه‌های فولادی',
  'partners.mobarakehSteelDescription': 'تأمین‌کننده فولاد و سازه‌های مقاوم گلخانه‌ای',
  'partners.tabrizPetrochemical': 'پتروشیمی تبریز',
  'partners.tabrizPetrochemicalSpecialization': 'مواد پلیمری و پلاستیک',
  'partners.tabrizPetrochemicalDescription': 'تولیدکننده مواد پلاستیکی مقاوم برای پوشش گلخانه',
  'partners.isfahanArea': '5,000 متر مربع',
  'partners.isfahanPartner': 'Van der Hoeven + Chehelsotoon',
  'partners.mashadArea': '8,000 متر مربع',
  'partners.mashadPartner': 'Van der Hoeven + شرکای داخلی',
  'partners.ardabilArea': '3,000 متر مربع',
  'partners.ardabilPartner': 'همکاری چندجانبه',
  
  // News page
  'news.title': 'اخبار و اطلاعات تخصصی',
  'news.subtitle': 'آخرین اخبار، فناوری‌ها و نوآوری‌های دنیای گلخانه‌سازی و کشاورزی مدرن',
  'news.heroTitle': 'اخبار و اطلاعات تخصصی',
  'news.heroSubtitle': 'آخرین اخبار، فناوری‌ها و نوآوری‌های دنیای گلخانه‌سازی و کشاورزی مدرن',
  'news.featured': 'اخبار ویژه',
  'news.recent': 'سایر اخبار',
  'news.categories': 'دسته‌بندی‌ها',
  'news.searchPlaceholder': 'جستجو در اخبار، مقالات و تگ‌ها...',
  'news.project': 'پروژه',
  'news.technology': 'فناوری',
  'news.product': 'محصولات',
  'news.international': 'بین‌المللی',
  'news.tips': 'نکات فنی',
  'news.research': 'تحقیقات',
  'news.events': 'رویدادها',
  'news.all': 'همه',
  'news.readMore': 'ادامه مطلب',
  'news.readTime': 'دقیقه',
  'news.date': 'تاریخ',
  'news.category': 'دسته‌بندی',
  'news.tags': 'برچسب‌ها',
  'news.noResults': 'نتیجه‌ای یافت نشد',
  'news.noResultsDesc': 'لطفاً کلمات کلیدی دیگری امتحان کنید',
  'news.articlesFound': 'مقاله یافت شد',
  'news.newsletter': 'عضویت در خبرنامه',
  'news.newsletterTitle': 'عضویت در خبرنامه',
  'news.newsletterDesc': 'آخرین اخبار و مقالات تخصصی گلخانه‌سازی را مستقیماً در ایمیل خود دریافت کنید',
  'news.emailPlaceholder': 'آدرس ایمیل شما',
  'news.subscribe': 'عضویت',
  
  // News categories
  'news.cat.all': 'همه',
  'news.cat.project': 'پروژه',
  'news.cat.products': 'محصولات',
  'news.cat.technology': 'فناوری',
  'news.cat.international': 'بین‌المللی',
  'news.cat.tips': 'نکات فنی',
  'news.cat.research': 'تحقیقات',
  'news.cat.events': 'رویدادها',
  
  // Contact page (modified)
  'contact.title': 'تماس با ما',
  'contact.subtitle': 'با کارشناسان آریا گرین هاوس در ارتباط باشید و مشاوره رایگان دریافت کنید',
  'contact.phone': 'تماس تلفنی',
  'contact.phoneDesc': 'برای مشاوره فوری با ما تماس بگیرید',
  'contact.email': 'ایمیل',
  'contact.emailDesc': 'پیام‌های خود را برای ما ارسال کنید',
  'contact.address': 'آدرس دفتر',
  'contact.addressDesc': 'برای ملاقات حضوری به آدرس زیر مراجعه کنید',
  'contact.fullAddress': 'تهران، خیابان مطهری، خیابان یوسفیان، بن‌بست شکوه، پلاک ۶',
  'contact.warehouses': 'انبارها',
  'contact.warehousesDesc': 'موقعیت انبارهای ما',
  'contact.warehouse1': 'انبار جاجرود',
  'contact.warehouse2': 'انبار شوش تهران',
  'contact.formTitle': 'فرم تماس',
  'contact.formDesc': 'فرم زیر را تکمیل کنید تا کارشناسان ما در اسرع وقت با شما تماس بگیرند',
  'contact.name': 'نام و نام خانوادگی',
  'contact.namePlaceholder': 'نام کامل خود را وارد کنید',
  'contact.email': 'ایمیل',
  'contact.emailPlaceholder': 'آدرس ایمیل خود را وارد کنید',
  'contact.phoneNumber': 'شماره تماس',
  'contact.phonePlaceholder': 'شماره تماس خود را وارد کنید',
  'contact.projectType': 'نوع پروژه',
  'contact.selectProjectType': 'نوع پروژه را انتخاب کنید',
  'contact.commercial': 'تجاری',
  'contact.research': 'تحقیقاتی',
  'contact.hydroponic': 'هیدروپونیک',
  'contact.traditional': 'سنتی',
  'contact.consultation': 'مشاوره',
  'contact.budget': 'بودجه تقریبی',
  'contact.selectBudget': 'بودجه تقریبی را انتخاب کنید',
  'contact.under100k': 'زیر ۱۰۰ میلیون تومان',
  'contact.budget100k500k': '۱۰۰ تا ۵۰۰ میلیون تومان',
  'contact.budget500k1m': '۵۰۰ میلیون تا ۱ میلیارد تومان',
  'contact.over1m': 'بالای ۱ میلیارد تومان',
  'contact.timeline': 'زمان‌بندی پروژه',
  'contact.selectTimeline': 'زمان‌بندی مورد نظر را انتخاب کنید',
  'contact.immediate': 'فوری',
  'contact.timeline1to3': '۱ تا ۳ ماه',
  'contact.timeline3to6': '۳ تا ۶ ماه',
  'contact.timeline6plus': 'بیش از ۶ ماه',
  'contact.subject': 'موضوع',
  'contact.subjectPlaceholder': 'موضوع پیام خود را وارد کنید',
  'contact.message': 'پیام',
  'contact.messagePlaceholder': 'توضیحات کامل پروژه و نیازهای خود را بنویسید...',
  'contact.characters': 'کاراکتر',
  'contact.sendMessage': 'ارسال پیام',
  'contact.sending': 'در حال ارسال...',
  'contact.successMessage': 'پیام شما با موفقیت ارسال شد. کارشناسان ما در اسرع وقت با شما تماس خواهند گرفت.',
  'contact.errorMessage': 'خطا در ارسال پیام. لطفاً دوباره تلاش کنید.',
  'contact.location': 'موقعیت مکانی',
  'contact.officeHours': 'ساعات کاری',
  'contact.saturday': 'شنبه',
  'contact.saturdayHours': '۸:۰۰ - ۱۷:۰۰',
  'contact.sunday': 'یکشنبه',
  'contact.sundayHours': '۸:۰۰ - ۱۷:۰۰',
  'contact.monday': 'دوشنبه',
  'contact.mondayHours': '۸:۰۰ - ۱۷:۰۰',
  'contact.tuesday': 'سه‌شنبه',
  'contact.tuesdayHours': '۸:۰۰ - ۱۷:۰۰',
  'contact.wednesday': 'چهارشنبه',
  'contact.wednesdayHours': '۸:۰۰ - ۱۷:۰۰',
  'contact.thursday': 'پنج‌شنبه',
  'contact.thursdayHours': '۸:۰۰ - ۱۷:۰۰',
  'contact.friday': 'جمعه',
  'contact.fridayHours': 'تعطیل',
  'contact.emergencySupport': 'پشتیبانی اضطراری',
  'contact.emergencySupportDesc': 'برای مشکلات فوری گلخانه‌ها در خارج از ساعات کاری',
  'contact.faq': 'سوالات متداول',
  'contact.faqDesc': 'پاسخ سوالات رایج در مورد تماس و خدمات',
  'contact.faq.q1': 'چگونه می‌توانم مشاوره رایگان دریافت کنم؟',
  'contact.faq.a1': 'شما می‌توانید از طریق تماس تلفنی، ایمیل یا تکمیل فرم تماس، درخواست مشاوره رایگان خود را ارسال کنید. کارشناسان ما در اسرع وقت با شما تماس خواهند گرفت.',
  'contact.faq.q2': 'زمان پاسخگویی به پیام‌ها چقدر است؟',
  'contact.faq.a2': 'معمولاً در کمتر از ۲۴ ساعت به پیام‌های شما پاسخ می‌دهیم. برای موارد فوری، بهتر است تماس تلفنی برقرار کنید.',
  'contact.faq.q3': 'آیا امکان بازدید از محل پروژه وجود دارد؟',
  'contact.faq.a3': 'بله، کارشناسان ما برای بررسی دقیق‌تر پروژه و ارائه مشاوره تخصصی، از محل پروژه بازدید می‌کنند.',
  'contact.faq.q4': 'هزینه مشاوره و بازدید چقدر است؟',
  'contact.faq.a4': 'مشاوره اولیه و بازدید برای پروژه‌های جدی کاملاً رایگان است. فقط در صورت عدم ادامه همکاری، هزینه بازدید محاسبه می‌شود.',
  'contact.faq.q5': 'آیا پشتیبانی ۲۴ ساعته دارید؟',
  'contact.faq.a5': 'برای مشتریان فعلی و مشکلات اضطراری گلخانه‌ها، پشتیبانی ۲۴ ساعته ارائه می‌دهیم. برای سایر موارد، در ساعات کاری پاسخگو هستیم.',
  
  // Product detail page
  'product.specifications': 'مشخصات فنی',
  'product.applications': 'کاربردها',
  'product.installationGuide': 'راهنمای نصب',
  'product.relatedProducts': 'محصولات مرتبط',
  'product.features': 'ویژگی‌ها',
  'product.benefits': 'مزایا',
  'product.technicalSpecs': 'مشخصات فنی',
  'product.usage': 'نحوه استفاده',
  'product.maintenance': 'نگهداری',
  'product.warranty': 'گارانتی',
  'product.availability': 'موجودی',
  'product.inStock': 'موجود',
  'product.outOfStock': 'ناموجود',
  'product.limitedStock': 'موجودی محدود',
  'product.orderNow': 'سفارش دهید',
  'product.addToCart': 'افزودن به سبد',
  'product.requestQuote': 'درخواست قیمت',
  'product.downloadCatalog': 'دانلود کاتالوگ',
  'product.shareProduct': 'اشتراک‌گذاری',
  'product.printPage': 'چاپ صفحه',
  'product.backToProducts': 'بازگشت به محصولات',
  
  // UV Thread specific translations
  'product.uvThread.title': 'نخ UV گلخانه',
  'product.uvThread.subtitle': 'نخ تابیده پلی‌پروپیلن با محافظت UV برای گلخانه‌ها',
  'product.uvThread.description': 'نخ UV گلخانه محصولی تخصصی برای نگهداری و هدایت گیاهان در گلخانه‌های مدرن است. این نخ با جنس پلی‌پروپیلن و محافظت UV ۴ درصد، مقاومت بالایی در برابر نور خورشید و شرایط محیطی دارد.',
  
  // Specifications
  'product.uvThread.specs.length': 'طول هر رول',
  'product.uvThread.specs.weight': 'وزن هر رول',
  'product.uvThread.specs.material': 'جنس',
  'product.uvThread.specs.uvProtection': 'محافظت UV',
  'product.uvThread.specs.type': 'نوع نخ',
  'product.uvThread.specs.colors': 'رنگ‌های موجود',
  'product.uvThread.specs.manufacturer': 'تولیدکننده',
  'product.uvThread.specs.lengthValue': '۲۰۰۰ متر',
  'product.uvThread.specs.weightValue': '۲ کیلوگرم',
  'product.uvThread.specs.materialValue': 'پلی‌پروپیلن (PP)',
  'product.uvThread.specs.uvProtectionValue': '۴ درصد',
  'product.uvThread.specs.typeValue': 'نخ تابیده',
  'product.uvThread.specs.colorsValue': 'سفید، سبز',
  'product.uvThread.specs.manufacturerValue': 'آریا گرین هاوس',
  
  // Applications
  'product.uvThread.applications.title': 'کاربردهای نخ UV گلخانه',
  'product.uvThread.applications.tomato': 'نگهداری گوجه فرنگی',
  'product.uvThread.applications.tomatoDesc': 'هدایت و نگهداری ساقه‌های گوجه فرنگی در رشد عمودی',
  'product.uvThread.applications.cucumber': 'نگهداری خیار',
  'product.uvThread.applications.cucumberDesc': 'پشتیبانی از رشد خیار و جلوگیری از شکستگی ساقه',
  'product.uvThread.applications.beans': 'نگهداری لوبیا',
  'product.uvThread.applications.beansDesc': 'هدایت رشد لوبیای بالارونده و نگهداری میوه‌ها',
  'product.uvThread.applications.pepper': 'نگهداری فلفل',
  'product.uvThread.applications.pepperDesc': 'پشتیبانی از شاخه‌های فلفل و جلوگیری از خم شدن',
  'product.uvThread.applications.herbs': 'گیاهان دارویی',
  'product.uvThread.applications.herbsDesc': 'نگهداری و هدایت گیاهان دارویی بالارونده',
  'product.uvThread.applications.flowers': 'گل‌های زینتی',
  'product.uvThread.applications.flowersDesc': 'پشتیبانی از ساقه‌های گل‌های بلند و ظریف',
  
  // Installation Guide
  'product.uvThread.installation.title': 'راهنمای نصب و استفاده',
  'product.uvThread.installation.step1': 'آماده‌سازی',
  'product.uvThread.installation.step1Desc': 'ابتدا محل نصب را تمیز کرده و ابزارهای مورد نیاز را آماده کنید',
  'product.uvThread.installation.step2': 'نقاط اتصال',
  'product.uvThread.installation.step2Desc': 'نقاط اتصال بالا و پایین را در فاصله مناسب نصب کنید',
  'product.uvThread.installation.step3': 'کشیدن نخ',
  'product.uvThread.installation.step3Desc': 'نخم ن از نقطه پایین به بالا کشیده و با کشش مناسب ببندید',
  'product.uvThread.installation.step4': 'بستن گیاه',
  'product.uvThread.installation.step4Desc': 'گیاه را با حلقه‌های نرم به نخ ببندید تا آسیب نبیند',
  'product.uvThread.installation.step5': 'کنترل دوره‌ای',
  'product.uvThread.installation.step5Desc': 'به طور منظم وضعیت نخ و اتصالات را بررسی کنید',
  
  // Features & Benefits
  'product.uvThread.features.title': 'ویژگی‌ها و مزایا',
  'product.uvThread.features.uvResistant': 'مقاوم در برابر UV',
  'product.uvThread.features.uvResistantDesc': 'محافظت ۴ درصدی در برابر اشعه ماورای بنفش',
  'product.uvThread.features.highStrength': 'مقاومت بالا',
  'product.uvThread.features.highStrengthDesc': 'قابلیت تحمل وزن تا ۱۵ کیلوگرم',
  'product.uvThread.features.weatherResistant': 'مقاوم در برابر آب و هوا',
  'product.uvThread.features.weatherResistantDesc': 'مقاومت در برابر رطوبت، باران و تغییرات دما',
  'product.uvThread.features.easyInstall': 'نصب آسان',
  'product.uvThread.features.easyInstallDesc': 'قابلیت نصب سریع و آسان بدون نیاز به ابزار خاص',
  'product.uvThread.features.longLasting': 'دوام بالا',
  'product.uvThread.features.longLastingDesc': 'عمر مفید طولانی در شرایط گلخانه‌ای',
  'product.uvThread.features.costEffective': 'مقرون به صرفه',
  'product.uvThread.features.costEffectiveDesc': 'قیمت مناسب با کیفیت بالا',
  
  // Maintenance
  'product.uvThread.maintenance.title': 'نگهداری و تعمیرات',
  'product.uvThread.maintenance.cleaning': 'تمیز کردن',
  'product.uvThread.maintenance.cleaningDesc': 'در صورت نیاز با آب و صابون ملایم تمیز کنید',
  'product.uvThread.maintenance.inspection': 'بازرسی دوره‌ای',
  'product.uvThread.maintenance.inspectionDesc': 'هر ماه وضعیت نخ و اتصالات را بررسی کنید',
  'product.uvThread.maintenance.replacement': 'تعویض',
  'product.uvThread.maintenance.replacementDesc': 'در صورت فرسودگی یا آسیب، نخ را تعویض کنید',
  'product.uvThread.maintenance.storage': 'نگهداری',
  'product.uvThread.maintenance.storageDesc': 'در محل خشک و دور از نور مستقیم خورشید نگهداری کنید',
  
  // Related Products
  'product.uvThread.related.title': 'محصولات مرتبط',
  'product.uvThread.related.clips': 'گیره‌های نگهدارنده',
  'product.uvThread.related.clipsDesc': 'گیره‌های مخصوص اتصال نخ به گیاه',
  'product.uvThread.related.hooks': 'قلاب‌های آویز',
  'product.uvThread.related.hooksDesc': 'قلاب‌های نصب در سقف گلخانه',
  'product.uvThread.related.tensioners': 'تنظیم‌کننده‌های کشش',
  'product.uvThread.related.tensionersDesc': 'ابزار تنظیم کشش نخ',
  'product.uvThread.related.supports': 'تیرهای نگهدارنده',
  'product.uvThread.related.supportsDesc': 'تیرهای فلزی برای نصب سیستم نگهداری'
};

export default faCommon;
